export type Subscription = {
  id: string;
  status: 'active' | 'cancelled' | 'deleted';
  paymentInterval: 'month' | 'year' | 'enterprise';
  planType: 'single_user' | 'multi_user';
  currentPeriodEndsAt: string;
  isActivated: boolean;
};
